import { render } from "./MessageAttachmentPreview.vue?vue&type=template&id=dc73133a&scoped=true"
import script from "./MessageAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./MessageAttachmentPreview.vue?vue&type=script&lang=js"

import "./MessageAttachmentPreview.vue?vue&type=style&index=0&id=dc73133a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc73133a"]])

export default __exports__